import React, { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import { computePageIcon, computePageIconColor, computePageTooltip } from '../ui.tools';
import { Col, Row } from 'react-bootstrap';
import { Icon, TableRowExpandedMobile, ToolTip, WinRedChip } from 'modules/common';
import GrossResultsDisplay from 'modules/pages/components/grossResultsDisplay.component';
import { convertEpochTime } from 'core/utilities';
import { TagIndexList } from '../page-tags/tag-index-list.component';
import { PagesDropdownMenu } from './dropdown-menu.component';

import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { ExpandedRowBody } from './expanded-row-body.component';

function PagesTableMobile({
  items,
  expandItem,
  expandedRows,
  dropdownAction,
  profileCandidate,
  refetch,
  uiFilter,
  toggleBulkAddTag,
  match
}) {
  const showBulkTagIcon = useMemo(() => {
    return false;
    // return uiFilter.length > 0;
  }, []);

  if (!items) return null;

  const mobileRows = items.map(item => {
    const { revv_uid, created_at, internalName, slug, type, pageGrossResults, billPayExists, authorEmail, tags } = item;

    const icon = computePageIcon(item);
    const iconColor = computePageIconColor(item);
    const toolTip = computePageTooltip(item);
    const isExpanded = expandedRows[revv_uid];
    const _expandItem = event => expandItem(event, revv_uid);

    return (
      <Fragment key={revv_uid}>
        <div className="list-item-card" tabIndex="0" role="link">
          <Row className="no-gutters">

            <Col xs="2" className="list-item-card-icon">
              <Link className="no-underline" to={`${match.url}/${revv_uid}`}>
                <ToolTip tooltip={toolTip}>
                  <Icon icon={icon} color={iconColor} />
                </ToolTip>
              </Link>
            </Col>
            <Col xs="7">
              <Link className="no-underline" to={`${match.url}/${revv_uid}`}>

                <div className="list-item-card-title">{internalName}</div>
                <div className="list-item-card-text">{slug}</div>
                <div className="list-item-card-text">
                  <GrossResultsDisplay type={type} pageGrossResults={pageGrossResults} />
                </div>
                <div className="list-item-card-text">
                  {convertEpochTime(created_at)} <br /> {authorEmail && `by ${authorEmail}`}
                </div>

              </Link>
              {billPayExists ? (
                <div className="list-item-card-text mt-2" onClick={_expandItem} role="button">
                  <WinRedChip variant="purple">
                    Bill-Pay
                    <Icon
                      className="ml-2"
                      color="purple"
                      icon={isExpanded ? 'minus-circle' : 'plus-circle'}
                      size="lg"
                    />
                  </WinRedChip>
                </div>
              ) : null}
            </Col>
            <Col xs="3" className="flex justify-end">
              <PagesDropdownMenu
                dropdownAction={dropdownAction}
                item={item}
                profileCandidate={profileCandidate}
                onClick={e => e.stopPropagation()}
              />

            </Col>
          </Row>
        </div>

        {isExpanded && (
          <TableRowExpandedMobile>
            <ExpandedRowBody item={item} />
          </TableRowExpandedMobile>
        )}
      </Fragment>
    );
  });

  return (
    <>
      {showBulkTagIcon ? (
        <div className="w-full flex justify-end px-3">
          <div
            onClick={toggleBulkAddTag}
            className="border border-mystic inline-flex rounded items-center cursor-pointer bg-catskill-white p-0.5 mb-3"
          >
            <Icon icon="tag" className="w-3.5 h-3.5 my-0 mr-1" />
            <span className="block mr-2">Bulk Add</span>
          </div>
        </div>
      ) : null}
      {mobileRows}
    </>
  );
}

PagesTableMobile.propTypes = {
  items: PropTypes.array.isRequired,
  navigateToItem: PropTypes.func.isRequired,
  dropdownAction: PropTypes.func.isRequired,
  expandItem: PropTypes.func.isRequired,
  expandedRows: PropTypes.object.isRequired,
  profileCandidate: PropTypes.object.isRequired,
  refetch: PropTypes.func.isRequired,
  uiFilter: PropTypes.array.isRequired,
  toggleBulkAddTag: PropTypes.func.isRequired,
};

export default PagesTableMobile;
